import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import Spin from "./Spin";

export const ConfirmDialog = ({
  open,
  handleClose,
  title,
  message,
  onAccept,
  titleColor = "#000",
  maxWidth = "lg",
  acceptButtonColor = "primary",
  acceptText = "Change",
}) => {
  const [spin, setSpin] = useState(false);
  return (
    <Dialog
      disableBackdropClick
      open={open}
      keepMounted
      onClose={handleClose}
      maxWidth={maxWidth}
    >
      <Spin spinning={spin}>
        <DialogTitle
          id="alert-dialog-slide-title"
          style={{ color: titleColor }}
        >
          {title}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText
            id="alert-dialog-slide-description"
            style={{ fontSize: "0.875rem" }}
          >
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
          <Button
            onClick={async (e) => {
              setSpin(true);
              await onAccept(e);
              setSpin(false);
              handleClose();
            }}
            variant="contained"
            color={acceptButtonColor}
            className="common_kissht_btn"
          >
            {acceptText}
          </Button>
        </DialogActions>
      </Spin>
    </Dialog>
  );
};
